<template>
    <MainContent 
        title='Crear nueva liquidación'
    >
        <template v-slot:header>
            <div v-if="! terminado">
                <CrearDireccionFiscalModal
                    @creado="reload++"
                    :disabled="creando"
                />
                <div class="pt-2">
                    <b>*Las liquidaciones solo se podrán solicitar una vez que haya pasado el evento</b> 
                </div>
            </div>
            <RecordatorioTituloComponent v-else />
        </template>
        <template v-slot:content>
            <ContentOrLoading>
                <ValidationObserver v-if="! terminado" tag="form" ref="observerLiquidacion" @submit.prevent="submitFirstStep()">
                    <div class="row" v-if="!loading">
                        <div class="col-12" v-if="teatro.liquidaciones_eventos_parciales">
                            <b-tabs v-model="activeTab">
                                <b-tab title="Liquidación Completa">
                                    <div class="row mt-4">
                                        <div class="col-12 col-lg-6" v-if="activeTab == 0">
                                            <DireccionFiscal :key="reload" :data="data" :disabled="creando || resumen_active" @direccionFiscal="getDatos" />
                                        </div>
                                        <div class="col-12 col-lg-6" v-if="data.direccionFiscal">
                                            <div class="form-group">
                                                <label for="fechas">Eventos disponibles:</label>
                                                <ValidationProvider name="eventos" :rules="activeTab == 0 ? 'required' : ''" mode="passive" v-slot="{ errors }">
                                                    <multiselect
                                                        v-model="data.evento"
                                                        :options="eventos_disponibles"
                                                        placeholder="Seleccionar eventos" 
                                                        track-by="id"
                                                        :custom-label="customLabel"
                                                        :multiple="teatro.liquidaciones_eventos_varios_eventos === 0 ? false : true"
                                                        :disabled="creando || resumen_active"
                                                    >
                                                        <template slot="noOptions"><strong>No dispones de más eventos para solicitar liquidación.</strong></template>
                                                    </multiselect>
                                                    <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"><b>{{ errors[0] }}</b></span>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                    </div>
                                </b-tab>

                                <b-tab title="Liquidaciones Parciales">
                                    <div class="row mt-4">
                                        <div class="col-12 col-lg-6" v-if="activeTab == 1">
                                            <DireccionFiscal :key="reload" :data="data" :disabled="creando || resumen_active" @direccionFiscal="getDatos" />
                                        </div>
                                        <div class="col-12 col-lg-6" v-if="data.direccionFiscal">
                                            <div class="form-group">
                                                <label for="fechas">Selecciona el rango de fechas:</label>
                                                <DatePickerRanger
                                                    :key="reload"
                                                    :dateRange="data"
                                                    :maxDate="maxDate"
                                                    :minDate="minDate"
                                                    :disabledDates="disabledDates"
                                                    @selected="selectedOption => { 
                                                        data = { 
                                                            ...data,
                                                            ...selectedOption
                                                        };
                                                    }"
                                                    :disabled="creando || resumen_active"
                                                />
                                                <span v-if="errorFechas" class="invalid-feedback mb-4 text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"><b>El campo rango de fechas es requerido</b></span>
                                            </div>
                                        </div>
                                    </div>
                                </b-tab>
                            </b-tabs>
                        </div>

                        <template v-else>
                            <div class="col-12 col-lg-6">
                                <DireccionFiscal :key="reload" :data="data" :disabled="creando || resumen_active" @direccionFiscal="getDatos" />
                            </div>
                            <div class="col-12 col-lg-6" v-if="data.direccionFiscal">
                                <div class="form-group">
                                    <label for="eventos-disponibles">Eventos disponibles:</label>
                                    <ValidationProvider name="eventos" rules="required" mode="passive" v-slot="{ errors }">
                                        <multiselect 
                                            v-model="data.evento" 
                                            :options="eventos_disponibles"
                                            placeholder="Seleccionar eventos" 
                                            track-by="id"
                                            :custom-label="customLabel"
                                            :multiple="teatro.liquidaciones_eventos_varios_eventos === 0 ? false : true"
                                            :disabled="creando || resumen_active"
                                        >
                                            <template slot="noOptions"><strong>No dispones de más eventos para solicitar liquidación.</strong></template>
                                        </multiselect>
                                        <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"><b>{{ errors[0] }}</b></span>
                                    </ValidationProvider>
                                </div>
                            </div>
                        </template>

                        <DatosFiscales
                            v-if="data.direccionFiscal"
                            :direccionFiscal.sync="data.direccionFiscal"
                            :disabled="creando || resumen !== null"
                        >
                            <template #metodosPago>
                                <div class="col-12" v-if="teatro.liquidaciones_eventos_taquilla">
                                    <div class="form-group">
                                        <label for="fechas">Métodos de pago:</label>
                                        <ValidationProvider name="metodos_pago" mode="passive" v-slot="{ errors }">
                                            <multiselect 
                                                v-model="data.metodos_pago_formatted" 
                                                :options="metodos_pago"
                                                placeholder="Selecciona métodos de pago" 
                                                label="nombre" 
                                                track-by="id"
                                                :multiple="true"
                                                :disabled="creando || resumen_active"
                                            >
                                                <template slot="noOptions"><strong>No hay métodos de pago.</strong></template>
                                            </multiselect>
                                            <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs" style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"><b>{{ errors[0] }}</b></span>
                                        </ValidationProvider>
                                    </div>
                                </div>
                            </template>

                            <b-button block @click="volver" v-if="resumen_active">
                                <i class="fa fa-arrow-up" style="margin-right: .65rem"></i>Editar datos<i class="fa fa-arrow-up" style="margin-left: .65rem"></i>
                            </b-button>
                        </DatosFiscales>

                        <ResumenProvisional
                            :resumen="resumen"
                            :fields="fields"
                            :creando="creando"
                            :total="total"
                            @crearLiquidacion="crearLiquidacion"
                        />
                    </div>
                    <LoaderComponent v-else />
                </ValidationObserver>
                <RecordatorioComponent
                    v-else
                    @continuar="continuar"
                />
            </ContentOrLoading>
        </template>
    </MainContent>
</template>

<script>
    import MainContent from '@/components/backend/components/MainContent';
    import ContentOrLoading from '@/components/backend/components/ContentOrLoading';
    import CrearDireccionFiscalModal from '@/components/backend/direcciones-fiscales/modals/CrearDireccionFiscalModal';
    import RecordatorioComponent from '@/components/backend/liquidaciones/common/RecordatorioComponent.vue';
    import RecordatorioTituloComponent from '@/components/backend/liquidaciones/common/RecordatorioTituloComponent.vue';
    import DatePickerRanger from '@/components/common/forms/DatePickerRanger';
    import DireccionFiscal from '@/components/backend/liquidaciones/common/DireccionFiscal.vue';
    import ResumenProvisional from '@/components/backend/liquidaciones/common/ResumenProvisional.vue';
    import DatosFiscales from '@/components/backend/liquidaciones/common/DatosFiscales.vue';

    export default {
        data() {
            return {
                data: {},
                eventos_disponibles: [],
                loading: false,
                resumen: null,
                terminado: false,
                creando: false,
                taquilla: false,
                maxDate: moment().subtract(1, 'days').format('L'),
                minDate: '02/01/2023',
                errorFechas: false,
                disabledDates: [],
                fields: [
                    { key: 'descripcion', label: 'Descripción' },
                    { key: 'total', label: 'Total' },
                    { key: 'importe', label: 'Importe Total' }
                ],
                activeTab: 0,
                reload: 1,
                resumen_active: false
            }
        },
        computed: {
            total() {
                let total = 0;

                if (this.resumen) {
                    this.resumen.forEach(linea => {
                        total += parseFloat(linea.importe);
                    });
                }

                return total;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            selected() {
                return this.data.evento || (this.data.endDate && this.data.startDate);
            },
            metodos_pago() {
                return this.$store.getters.getTeatro.metodos_pago_eventos_ventas.filter(metodo_pago => metodo_pago.id !== 4);
            },
            manager() {
                return this.$store.getters.getFooter;
            }
        },
        watch: {
            activeTab(newTab) {
                this.data.direccionFiscal = null;
                if (newTab === 0) {
                    this.data.evento = null;
                    this.data.metodos_pago_formatted = [];
                } else if (newTab === 1) {
                    delete this.data.startDate;
                    delete this.data.endDate;
                    this.errorFechas = false;
                }
                this.reload++;
                this.resumen = null;
                this.resumen_active = false;
            }
        },
        methods: {
            getDisabledDates() {
                this.loading = true;

                const params = {
                    filters : {
                        direccion_fiscal_id: this.data.direccionFiscal?.id
                    }
                };

                this.$store.dispatch(this.config.getVuexAlias('back.liquidaciones.eventos.last.date'), params).then(res => {
                    this.disabledDates = res.data.fechas;
                }).finally(() => {
                    this.loading = false;
                });
            },
            getEventosDisponibles() {
                this.loading = true;

                const params = {
                    filters : {
                        direccion_fiscal_id: this.data.direccionFiscal?.id
                    }
                };

                this.$store.dispatch(this.config.getVuexAlias('back.liquidaciones.eventos.disponibles'), params).then(res => {
                    this.eventos_disponibles = res.data.data;
                }).finally(() => {
                    this.loading = false;
                });
            },
            getDatos() {
                if (this.activeTab == 0) {
                    this.getEventosDisponibles();
                } else {
                    this.getDisabledDates();
                }
            },
            async submitFirstStep() {
                const isValid = await this.$refs.observerLiquidacion.validate();
                if(isValid) {
                    this.getResumenLiquidacion();
                } else {
                    this.scrollTo(".is-invalid");
                }
            },
            getResumenLiquidacion() {
                this.data.filters = {};
                if (!this.data.endDate && !this.data.startDate) {
                    this.data.eventos = this.teatro.liquidaciones_eventos_varios_eventos ? this.data.evento : [this.data.evento];
                } else {
                    this.data.eventos = [];
                }

                if (this.data.metodos_pago_formatted) this.data.metodos_pago = this.data.metodos_pago_formatted.map(metodo_pago => metodo_pago.id);
                if (this.teatro.liquidaciones_eventos_taquilla) this.data.taquilla = true;

                this.$store.dispatch(this.config.getVuexAlias('back.liquidaciones.eventos.resumen'), this.data).then(res => {
                    this.resumen = res.data.data;
                    this.resumen_active = true;
                    this.scrollTo('#resumen');
                });   
                
            },
            crearLiquidacion() {
                this.creando = true;
                this.data.filters = {};
                if (!this.data.endDate && !this.data.startDate) {
                    this.data.eventos = this.teatro.liquidaciones_eventos_varios_eventos ? this.data.evento : [this.data.evento];
                } else {
                    this.data.eventos = [];
                }

                this.$store.dispatch(this.config.getVuexAlias('back.liquidaciones.eventos.crear'), this.data).then(res => {
                    this.$toast.success(res.data.message);
                    this.terminado = true;
                    this.creando = false;
                });
            },
            continuar() {
                this.$router.push({ name: 'back.liquidaciones.eventos.index' });
            },
            volver() {
                this.resumen = null;
                this.resumen_active = false;
            },
            customLabel(evento) {
                var name = evento.name;

                if (this.manager.tipo === 1) {
                    name += ' (' + evento.lista_nombre + ')';
                }

                return name;
            },
            scrollTo(paso) {
                this.$nextTick(() => {
                    this.$scrollTo(paso, 100);
                });
            }
        },
        components: {
            MainContent,
            ContentOrLoading,
            CrearDireccionFiscalModal,
            RecordatorioComponent,
            RecordatorioTituloComponent,
            DatePickerRanger,
            DireccionFiscal,
            ResumenProvisional,
            DatosFiscales
        }
    }
</script>
